import { render, staticRenderFns } from "./LeaveTbSyncTaskList.vue?vue&type=template&id=5975df3a&scoped=true"
import script from "./LeaveTbSyncTaskList.vue?vue&type=script&lang=js"
export * from "./LeaveTbSyncTaskList.vue?vue&type=script&lang=js"
import style0 from "./LeaveTbSyncTaskList.vue?vue&type=style&index=0&id=5975df3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5975df3a",
  null
  
)

export default component.exports